import type { CopilotMode } from '@fluentui-copilot/react-provider';
import type { ComponentProps, ComponentState, Slot } from '@fluentui/react-components';

export type SystemMessageSlots = {
  root: Slot<'div'>;
  icon?: Slot<'span'>;
  message?: Slot<'span'>;
  /*
   * The accessibleHeading slot is only exposed to screen reader users, and is used in two ways:
   * 1. It prepends the text content in the message's accessible name, e.g. "System message: [text content]"
   * 2. It is exposed as a heading to facilitate easy heading-based message navigation
   * NOTE: we recommend the text content of this slot to be "System message: " or "System message at [timestamp]: ".
   */
  accessibleHeading?: Slot<'h6', 'div'>;
};

/**
 * SystemMessage Props
 */
export type SystemMessageProps = ComponentProps<SystemMessageSlots> &
  CopilotMode & {
    /*
     * Whether this message should be the default focused item in the CopilotChat container
     */
    defaultFocused?: boolean;
    /*
     * Defines a screen reader live region message to be fired on any updates to the prop value.
     * By default SystemMessage announces its full text when it finishes loading, and if announcement is undefined.
     */
    announcement?: string;
  };

/**
 * State used in rendering SystemMessage
 */
export type SystemMessageState = ComponentState<SystemMessageSlots> & Required<Pick<SystemMessageProps, 'mode'>> & {};
